import React from 'react';
import { Link } from 'react-router-dom';
/** lib **/
import classNames from 'classnames';
import { SupporterVoiceList } from 'lib/supporter-voice';
/** styles,images **/
import s from '../../styles/organisms/photo-gallery.module.scss';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

/** 登録会員様のペット写真館（/about 下部） */
export const PhotoGallery: React.FC = () => {
  const photos = [...SupporterVoiceList].reverse().slice(0, 8);
  return (
    <div className={s.photoGalleryWrapper}>
      <div className={s.titleWrap}>
        <h3 className={s.title}>登録会員様の<br className={s.spOnly} />ペット写真館</h3>
        <Link className={classNames(s.moreLink, s.pcOnly)} to="/supporters-voice">
          <p>もっとみる</p>
          <GreenCircleArrow className={s.moreLinkIcon} />
        </Link>
      </div>
      <div className={s.imageList}>
        {photos.map((item, index) => (
          <div className={s.image} key={index}>
            <img src={require(`assets/images/${item.image}`)} alt={item.spec} />
          </div>
        ))}
      </div>
      <Link className={classNames(s.moreLink, s.spOnly)} to="/supporters-voice">
        <p>もっとみる</p>
        <GreenCircleArrow className={s.moreLinkIcon} />
      </Link>
    </div>
  );
};
